import RefreshIcon from "@mui/icons-material/CachedRounded";
import { Box, Button, Container, Stack } from "@mui/material";
import { useState } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import useFetch from "@entrilia/shared/hooks/useFetch";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import WorkflowTemplatesGrid from "./WorkflowTemplatesGrid";

const WorkflowTemplatesPage = () => {
  usePageTitle("Workflow Templates");

  const [workflowTemplates, fetchError, { fetch }] = useFetch(adminApi.getCurrentWorkflowTemplateVersions);
  const [searchTerm, setSearchTerm] = useState("");

  if (fetchError) {
    logError(fetchError, "[WorkflowTemplatesPage] getWorkflowTemplates");
    return <DataLoadingFailed />;
  }

  const handleSearch = (value: string) => {
    setSearchTerm(value.trim().toLocaleLowerCase());
  };

  const loading = workflowTemplates === undefined;
  const templates = workflowTemplates ?? [];

  const filteredTemplates = searchTerm
    ? templates.filter(
        (template) =>
          template.category.toLocaleLowerCase().includes(searchTerm) ||
          template.name.toLocaleLowerCase().includes(searchTerm)
      )
    : [...templates];

  return (
    <>
      <GeneralPageHeader title="Workflow Templates" />
      <Container maxWidth={false} sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", mb: 2, pt: 2.5 }}>
          <RecordCounter records={filteredTemplates.length} totalRecords={templates.length} hide={loading} />
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <SearchField debounceTimeMs={300} onSearch={handleSearch} />
            <Button
              variant="outlined"
              color="secondary"
              disabled={loading}
              startIcon={<RefreshIcon />}
              onClick={() => fetch()}
            >
              Refresh
            </Button>
          </Stack>
        </Box>

        <WorkflowTemplatesGrid rows={filteredTemplates} loading={loading} />
      </Container>
    </>
  );
};

export default WorkflowTemplatesPage;
